import { render } from "./pageLoader.vue?vue&type=template&id=3afecb8d&scoped=true"
import script from "./pageLoader.vue?vue&type=script&lang=js"
export * from "./pageLoader.vue?vue&type=script&lang=js"

import "./pageLoader.vue?vue&type=style&index=0&id=3afecb8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afecb8d"]])

export default __exports__